/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ productName: NonNullable<unknown> }} Admin_Resource_Form_Select_Product_For_External_BookingsInputs */

const en_admin_resource_form_select_product_for_external_bookings = /** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.productName} for external bookings`)
};

const de_admin_resource_form_select_product_for_external_bookings = /** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.productName} für externe Buchungen auswählen`)
};

const es_admin_resource_form_select_product_for_external_bookings = /** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccionar ${i?.productName} para reservas externas`)
};

const fr_admin_resource_form_select_product_for_external_bookings = /** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sélectionnez ${i?.productName} pour les réservations externes`)
};

const nl_admin_resource_form_select_product_for_external_bookings = /** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecteer ${i?.productName} voor externe reserveringen`)
};

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */
const it_admin_resource_form_select_product_for_external_bookings = en_admin_resource_form_select_product_for_external_bookings;

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */
const pt_br2_admin_resource_form_select_product_for_external_bookings = en_admin_resource_form_select_product_for_external_bookings;

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */
const pl_admin_resource_form_select_product_for_external_bookings = en_admin_resource_form_select_product_for_external_bookings;

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */
const hu_admin_resource_form_select_product_for_external_bookings = en_admin_resource_form_select_product_for_external_bookings;

/** @type {(inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs) => LocalizedString} */
const ro_admin_resource_form_select_product_for_external_bookings = en_admin_resource_form_select_product_for_external_bookings;

/**
* | output |
* | --- |
* | "Select {productName} for external bookings" |
*
* @param {Admin_Resource_Form_Select_Product_For_External_BookingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_select_product_for_external_bookings = /** @type {((inputs: Admin_Resource_Form_Select_Product_For_External_BookingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Select_Product_For_External_BookingsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_select_product_for_external_bookings(inputs)
	if (locale === "de") return de_admin_resource_form_select_product_for_external_bookings(inputs)
	if (locale === "es") return es_admin_resource_form_select_product_for_external_bookings(inputs)
	if (locale === "fr") return fr_admin_resource_form_select_product_for_external_bookings(inputs)
	if (locale === "nl") return nl_admin_resource_form_select_product_for_external_bookings(inputs)
	if (locale === "it") return it_admin_resource_form_select_product_for_external_bookings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_select_product_for_external_bookings(inputs)
	if (locale === "pl") return pl_admin_resource_form_select_product_for_external_bookings(inputs)
	if (locale === "hu") return hu_admin_resource_form_select_product_for_external_bookings(inputs)
	return ro_admin_resource_form_select_product_for_external_bookings(inputs)
});
export { admin_resource_form_select_product_for_external_bookings as "admin.resource_form.select_product_for_external_bookings" }